import { Feature } from '@/pinia/feature'
import { productsList } from './products'
import { assetList } from './assets'
import { systemList } from './system'

const children: Feature[] = [assetList, productsList, systemList]

export const entities: Feature = {
  name: 'entities',
  enabled: true,
  title: {
    en: 'Entities',
    sv: 'Entiteter'
  },
  component: 'FeatureCard',
  access: children.flatMap((child) => child.access || []),
  isRoute: true,
  props: {
    icon: 'IconBox',
    disableIsDrawPointActive: true,
    enableFullscreen: true
  },
  children: [
    {
      name: 'lists',
      enabled: true,
      title: {
        en: 'Entity Lists',
        sv: 'Entitetslistor'
      },
      children
    }
  ]
}
